import React from 'react'
import { TitleSectionProps } from './types'

export const StyledTitleSection: React.FC<TitleSectionProps> = (props: TitleSectionProps) => {
  return (
    <section className="flex flex-col gap-XL items-center pb-2XL tablet:pb-4XL" style={{letterSpacing: '.02em'}}>
      <h2 className="text-L font-bold tablet:text-3XL">{props.title}</h2>
      <p className="text-center text-S tablet:text-M" style={{ lineHeight: '1.75' }}>
        {props.text.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < props.text.length - 1 && <br />}
          </React.Fragment>
        ))}
      </p>
    </section>
  )
}
